import { atom } from "recoil";
import { v4 } from "uuid";

export interface ISimpliciAuthContainer {
  instance_id?: string;
  clientId?: string;
  clientSecret?: string;
  env?: string;
  lang?: string;
  on_step_change?: (event: any) => void;
  on_error?: (event: any) => void;
  on_complete?: (event: any) => void;
  on_loaded?: () => void;
  page?: "signin" | "signup";
  default_user?: any;
  iscombinedinput?: "true" | "false" | boolean;
  hide_navigation?: "true" | "false" | boolean;
  auto_navigate?: "true" | "false" | boolean;
  verified_user?: {
    name: string;
    email: string;
    phone: string;
    userImage: string;
  };
  sso_user_data?: any;
  styles?: any;
  support_signin_methods?: string[];
}

export interface InstanceDetails {
  token: {
    expiration: string | null;
  };
  userId: string | null;
  _id: string;
  name: string;
  authId: string;
  description: string;
  logo: string | null;
  authInstanceURIs: {
    loginURI: string;
    redirectURI: string;
    description: string;
  };
  onboardingflow: string;
  whitelistingUrls: string[];
  signUp: {
    required: boolean;
    scope: string[];
  };
  properties: boolean;
  providers: any[]; // Assuming any[] as no information is given
  methods: {
    biometric: boolean;
    otp: boolean;
    mobileApproval: boolean;
  };
  settings: {
    biometric: {
      liveness: boolean;
      biometric: boolean;
      facialRecognition: boolean;
      palmPrintVerification: boolean;
      facialRecognitionRequired: boolean;
      palmPrintVerificationRequired: boolean;
      livenessRequired: boolean;
      numberOfGestures: number | null;
      gestureSetting: {
        blink: number;
        openMouth: number;
        pucker: number;
        rotateHeadToLeft: number;
        rotateHeadToRight: number;
        tiltHeadUp: number;
        tiltHeadDown: number;
      };
      gestures: any[]; // Assuming any[] as no information is given
    };
  };
  refresh: {
    absoluteExpiration: boolean;
    absoluteLifetime: number | null;
    inactivityExpiration: boolean;
    inactivityLifetime: number | null;
    rotational: boolean;
    expiration: number | null;
    reuseInterval: number | null;
  };
  createdAt: string;
  updatedAt: string;
  __v: number;
}

export const WebComponentConfigState = atom<ISimpliciAuthContainer>({
  key: v4(),
  default: { instance_id: "", env: "stage", lang: "en", page: "signin" },
});

type ICurrentScreenType =
  | "signin"
  | "signup"
  | "unauthoried"
  | "loading"
  | "success";

export const CurrentScreenState = atom<ICurrentScreenType>({
  key: v4(),
  default: "signin",
});
export const CurrentUserInfo = atom({
  key: v4(),
  default: {},
});

export const InstanceDetailsState = atom<Partial<InstanceDetails>>({
  key: v4(),
  default: {},
});
